import Konva from 'konva';
import GraphicBase from './base';
import * as PanoramaUrl from '../assets/pointer.png';

class GraphicPanoramaPoint extends GraphicBase {
  constructor(payload, stage) {
    super(payload, stage);

    this.canDraggable = false;
  }

  build() {
    const { data, id, stage } = this;

    const p = stage.pointDict[data[0]];
    if (!p) return;
    const imageObj = new Image();
    imageObj.src = PanoramaUrl.default;

    let width = 30;
    if (stage.payload.config && stage.payload.config.panorama) {
      width = stage.payload.config.panorama.width;
    }

    this.ele = new Konva.Image({
      id,
      image: imageObj,
      pid: data[0],
      width,
      height: width,
      x: p.x,
      y: p.y,
      opacity: 1,
      offsetX: width / 2,
      offsetY: width / 2,
    });

    this.ele.on('click', (e) => {
      stage.pointClickHandler(e);
    });

    stage.tmpLayer.add(this.ele);
    this.layer = stage.tmpLayer;

    return this.ele;
  }
}

export default GraphicPanoramaPoint;
